import reducer, { initialState } from '../../../reducers/userInfo/verifyUpdatePhoneNumberCode';
import * as actions from '../../../actions/userInfo/verifyUpdatePhoneNumberCode';

const fn = { reducer, initialState, actions };
export default fn;
 
